import script from "./Testimonial.vue?vue&type=script&setup=true&lang=js"
export * from "./Testimonial.vue?vue&type=script&setup=true&lang=js"

import "./Testimonial.vue?vue&type=style&index=0&id=1f4a5eb7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f4a5eb7"]])

export default __exports__